import React from 'react'
import { NewsDetail } from '../../component/News/detail'

export const NewsDetailPage = () => {
    return (
        <NewsDetail />
    )
}
